import { Component , OnInit} from '@angular/core';
import { Router} from '@angular/router';
import {UserService} from "../../services/user.service";
import {User} from "../../models/user";

@Component({
	moduleId: module.id,
	selector: 'nav-tabs',
	templateUrl: 'nav-tabs.html',
	styleUrls: ['nav-tabs.scss']
})

export class NavTabsComponent implements OnInit {
    accountRole;

    constructor(
        private userService: UserService,
        private router: Router
    ) { };


    ngOnInit(): void {
        this.accountRole = this.userService.accountRole;
    };

    isAdmin(): boolean {
        return this.userService.isSuper;
    }

    isUserTab(url: string): boolean {
        return /^\/user/.test(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-tabs/nav-tabs.component.ts